import * as types from "../../constants";
import { getSessionData } from "../../utils/sessionAuth";

const storedSession = getSessionData();

export default function reducer(
  state = {
    user: {
      email: null,
      name: null,
      balance: storedSession ? storedSession.balance : null,
    },
  },
  actions
) {
  switch (actions.type) {
    case types.AUTH_SIGN_IN_SUCCESS:
      return {
        ...state,
        user: {
          email: actions.email,
          name: actions.name,
          balance: actions.balance,
        },
      };

    case types.AUTH_USER_BALANCE_UPDATE_SUCCESS:
      return {
        ...state,
        user: {
          email: actions.email,
          name: actions.name,
          balance: actions.balance,
        },
      };

    case types.AUTH_SIGN_OUT:
      return {
        ...state,
        user: undefined,
      };

    default:
      return state;
  }
}
